<template>
  <div>
    <GridLayout class="mx-10" :width="255">
      <MyClientCard
        v-for="client in myClients"
        :key="`my-client-card-${client.id}`"
        :client="client"
        style="width: 255px;"
        @click.native="goToClient(client)"
      />
    </GridLayout>
    <InfiniteLoader v-model="loading" :schema="myClientsSchema" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import MyClientCard from "@/pages/MyClients/components/MyClientCard";
import MyClientProfileModal from "@/pages/MyClients/components/MyClientProfileModal";

export default {
  name: "MyClientsIndex",
  components: {
    MyClientCard
  },
  props: {},
  computed: {
    ...mapGetters({
      myClients: "getMyClients"
    })
  },
  data() {
    return {
      myClientsSchema: {
        action: "fetchMyClients",
        getter: "getMyClients",
        pagination: "getMyClientsPagination",
        clean: "resetMyClients"
      },
      loading: false
    };
  },
  methods: {
    goToClient(client) {
      this.$modal.show(
        MyClientProfileModal,
        {
          client
        },
        {
          name: "MyClientProfileModal",
          classes:
            "MyClientProfileModal rounded-xl rounded-r-none overscroll-contain",
          transition: "vm-transition--side-card",
          height: "100%",
          maxWidth: 600,
          shiftX: 1.0,
          scrollable: true,
          adaptive: true
        }
      );
    }
  },
  created() {
    if (this.$route?.params?.objectId) {
      const client = this.myClients[0];
      // TODO: Replace that with the actual search of the client
      // consider doing an api call
      this.goToClient(client);
    }
  }
};
</script>

<style></style>
